export default __webpack_public_path__ + "static/media/lta_logo.c6f7b6f6.png";